import React from 'react';
import * as Icon from 'react-feather';
import {Link} from '@remix-run/react';

const Features = ({features}) => {
  return (
    <>
      <div
        className="boxes-area"
        style={{marginTop: '5rem', marginBottom: '-3rem'}}
      >
        <div className="container">
          <div className="row justify-content-center">
            {features.map((feature, index) => (
              <div
                key={index}
                className="col-lg-3 col-sm-6"
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1200"
                data-aos-once="false"
              >
                <div className="single-box">
                  <div className="icon">
                    <img src={feature?.media} alt="Icon" />
                  </div>

                  <h3>
                    <Link to="/feature-details">{feature?.title}</Link>
                  </h3>

                  <p>{feature?.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
